import { Angulartics2Piwik } from 'angulartics2/piwik';
import { Component, OnInit } from '@angular/core';
import { Angulartics2AppInsights } from 'angulartics2/appinsights';

import {MatDialog} from '@angular/material/dialog';
import { DialogDemoInformationComponent } from './angular-material/components/dialog-demo-information.component';
import { SelfThemerService } from 'wg-themer';
import { themes } from './themes';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private angulartics2Piwik: Angulartics2Piwik,
    public dialog: MatDialog,
    private angulartics2AppInsights: Angulartics2AppInsights,
    private selfStyler: SelfThemerService ) {

    this.angulartics2Piwik.startTracking();
    this.angulartics2AppInsights.startTracking();
    selfStyler.configure('./assets/images', themes)
  }

  ngOnInit() {
    //this.openDialog();
  }

  openDialog() {

    const isDemoInformationModalShown = localStorage.getItem('isDemoDialogShown');

    if(isDemoInformationModalShown){
      return;
    }

    localStorage.setItem('isDemoDialogShown', "true");

    const dialogRef = this.dialog.open(DialogDemoInformationComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
}
